export const getError = (state, actions) => {
  const errors = actions.map(action => state.error[action]);
  for (const error of errors) {
    if (error) {
      return error;
    }
  }
};
